import CodeSelect from './Index.vue'
CodeSelect.install = function(Vue) {
  Vue.component(CodeSelect.name, CodeSelect)
}


export default CodeSelect
